<template>
  <Layout>
    <div class="row">
      <PageHeader class="col-11" title="RPO Dashboard" />
    </div>
    <AllIncident />
  </Layout>
</template>

<script>
import Layout from "@/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import AllIncident from "./all-incidents-table.vue";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Incident Management",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {};
  },

  components: {
    Layout,
    PageHeader,
    AllIncident,
  },
};
</script>

